import { render, staticRenderFns } from "./FunderDashboard.vue?vue&type=template&id=ca91c578"
import script from "./FunderDashboard.vue?vue&type=script&lang=js"
export * from "./FunderDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca91c578')) {
      api.createRecord('ca91c578', component.options)
    } else {
      api.reload('ca91c578', component.options)
    }
    module.hot.accept("./FunderDashboard.vue?vue&type=template&id=ca91c578", function () {
      api.rerender('ca91c578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/dashboard/FunderDashboard.vue"
export default component.exports